import styles from "../../styles/shared/ai-trade-suggestion/BacktestChart.module.css";
import useSuggestedSignal from "../../hooks/useSuggestedSignal";
import { Skeleton } from "antd";
import { FaChartColumn } from "react-icons/fa6";
import EquityChart from "./EquityChart";
import useFetchExchanges from "../../hooks/api/useFetchExchanges";

function BacktestChart({ coin, exchange, timeframe, loading = false }) {
  const { liveSuggestionLoading, chartData } = useSuggestedSignal({
    coin,
    timeframe,
    oppositeSignal: "",
  });

  const showLoading = loading || liveSuggestionLoading;

  const { exchanges = [] } = useFetchExchanges();
  const exchangeName = exchanges?.find((ex) => ex?.id === exchange)?.name;

  return (
    <div className={styles.container}>
      {showLoading && (
        <Skeleton.Node active className={styles.loader}>
          <FaChartColumn color="#bfbfbf" size={30} />
        </Skeleton.Node>
      )}

      {!chartData && !showLoading && (
        <div className={styles.chartPlaceholder}>
          Click "Run AI Backtest" for {coin}/USDT on {exchangeName}
          {timeframe ? ` (${timeframe})` : ""} to perform the live backtest.
        </div>
      )}

      {chartData && !showLoading && <EquityChart data={chartData} />}
    </div>
  );
}

export default BacktestChart;
